up.compiler('[attendees-and-vehicles-summary-btn]', (element) => {
  element.addEventListener('click', () => {
    let html  = document.querySelector("[attendees-and-vehicles-summary]").outerHTML
    up.layer.open({ fragment: html, target: '[attendees-and-vehicles-summary]', class: 'up-modal-white' })
  })
})
